import type { Document } from "@contentful/rich-text-types"

export const isDocument = (bodyCopy: any): bodyCopy is Document => {
  return (bodyCopy as Document).content !== undefined
}
